import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const SupplierInfoModal = ({ onClose, sellerId, productId, userId }) => {
  const [seller, setSeller] = useState(null);
  const [ratingData, setRatingData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showRatingForm, setShowRatingForm] = useState(false);
  const [productRating, setProductRating] = useState(0);
  const [serviceRating, setServiceRating] = useState(0);
  const [hoveredProductRating, setHoveredProductRating] = useState(0);
  const [hoveredServiceRating, setHoveredServiceRating] = useState(0);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (sellerId) {
      fetchSeller();
      fetchRating();
    }
  }, [sellerId]);

  const fetchSeller = async () => {
    try {
      const formData = new FormData();
      formData.append("seller_id", sellerId);

      const res = await fetch(
        "https://cyberathon.com/streekatha/API/index.php/Master_controller/get_by_id_seller_registration",
        {
          method: "POST",
          body: formData,
        }
      );

      const result = await res.json();

      if (result.status && result.data) {
        setSeller(result.data);
      }
    } catch (err) {
      console.error("Seller fetch error", err);
    } finally {
      setLoading(false);
    }
  };

  const fetchRating = async () => {
    try {
      // const formData = new FormData();
      // formData.append("seller_id", sellerId);

      const res = await fetch(
        "https://cyberathon.com/streekatha/API/index.php/Master_controller/get_by_id_rating",
        {
          method: "POST",
          body: JSON.stringify({ seller_id: sellerId }),
        }
      );

      const result = await res.json();

      if (result.status && result.data) {
        setRatingData(result.data);
      }
    } catch (err) {
      console.error("Rating fetch error", err);
    }
  };

  const handleSubmitRating = async () => {

    const userId = localStorage.getItem("user_id");

if (!userId) {
  alert("Please login to submit rating");
  return;
}

  if (!productRating || !serviceRating) {
    alert("Please provide both product and service ratings");
    return;
  }

  setSubmitting(true);

  try {
    const payload = {
      seller_id: sellerId,
      product_id: productId,
      user_id: userId,
      product_quality_rating: productRating,
      service_quality_rating: serviceRating,
    };

    console.log("📦 Rating Payload:", payload);

    const res = await fetch(
      "https://cyberathon.com/streekatha/API/index.php/Master_controller/add_rating",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      }
    );

    const result = await res.json();
    console.log("✅ Rating API Response:", result);
  

    if (result.status === true || result.status === "true") {
      alert("Rating submitted successfully!");
      setShowRatingForm(false);
      fetchRating(); // Refresh ratings
    } else {
      alert(result.message || "Failed to submit rating");
    }
  } catch (err) {
    console.error("❌ Rating submission error", err);
    alert("Error submitting rating");
  } finally {
    setSubmitting(false);
  }
};


  const renderStars = (rating, onHover, onClick, hoveredRating) => {
    return (
      <div className="star-rating">
        {[1, 2, 3, 4, 5].map((star) => (
          <span
            key={star}
            className={`star ${
              star <= (hoveredRating || rating) ? "filled" : ""
            }`}
            onMouseEnter={() => onHover && onHover(star)}
            onMouseLeave={() => onHover && onHover(0)}
            onClick={() => onClick && onClick(star)}
          >
            ★
          </span>
        ))}
      </div>
    );
  };

  const calculateAverageRating = (rating) => {
    return rating ? parseFloat(rating).toFixed(1) : "0.0";
  };

  return (
    <div className="supplier-modal-overlay" onClick={onClose}>
      <div className="supplier-modal-box" onClick={(e) => e.stopPropagation()}>
        <button className="close-btn" onClick={onClose}>
          ×
        </button>

        {loading && <p>Loading supplier info...</p>}

        {!loading && seller && (
          <>
            <h3 className="modal-title">About the Seller</h3>

            <div className="seller-header">
              <div className="seller-info">
                <h4 className="seller-name">
                  {seller.business_name}
                  {/* <span className="seller-badge">4.2★</span> */}
                </h4>
                {/* <p className="seller-description">
                  Made in India Product, Solid wood Furniture Range
                </p>
                <p className="seller-since">
                  <span className="label">Seller since</span>
                  <span className="value">6 years 5 months</span>
                </p> */}
                <Link
                  to={`/contact-supplier/${productId}/${sellerId}`}
                  className="contact-link"
                >
                  Contact Seller
                </Link>
              </div>

              <div className="rating-circles">
                <div className="rating-circle">
                  <div className="circle-content">
                    <span className="rating-value">
                      {calculateAverageRating(
                        ratingData?.product_quality_rating
                      )}
                    </span>
                  </div>
                  <p className="rating-label">Product Quality</p>
                  <button
                    className="details-link"
                    onClick={() => setShowRatingForm(!showRatingForm)}
                  >
                    {showRatingForm ? "Cancel" : "Rate"}
                  </button>
                </div>

                <div className="rating-circle">
                  <div className="circle-content">
                    <span className="rating-value">
                      {calculateAverageRating(
                        ratingData?.service_quality_rating
                      )}
                    </span>
                  </div>
                  <p className="rating-label">Service Quality</p>
                  <button
                    className="details-link"
                    onClick={() => setShowRatingForm(!showRatingForm)}
                  >
                    {showRatingForm ? "Cancel" : "Rate"}
                  </button>
                </div>
              </div>
            </div>

            {showRatingForm && (
              <div className="rating-form">
                <h4>Rate this Seller</h4>

                <div className="rating-input-group">
                  <label>Product Quality</label>
                  {renderStars(
                    productRating,
                    setHoveredProductRating,
                    setProductRating,
                    hoveredProductRating
                  )}
                  <span className="rating-text">
                    {productRating > 0 ? `${productRating} out of 5` : ""}
                  </span>
                </div>

                <div className="rating-input-group">
                  <label>Service Quality</label>
                  {renderStars(
                    serviceRating,
                    setHoveredServiceRating,
                    setServiceRating,
                    hoveredServiceRating
                  )}
                  <span className="rating-text">
                    {serviceRating > 0 ? `${serviceRating} out of 5` : ""}
                  </span>
                </div>

                <button
                  className="submit-rating-btn"
                  onClick={handleSubmitRating}
                  disabled={submitting}
                >
                  {submitting ? "Submitting..." : "Submit Rating"}
                </button>
              </div>
            )}

            <div className="seller-note">
              <p className="note-text">
                Seller Score is calculated by Gharshya based on customer
                feedback and seller's performance
              </p>
            </div>

            <div className="manufacturer-details">
              <h5>Manufacturer Details</h5>
              <p>
                <strong>Supplier Business Name:</strong> {seller.business_name}
                <br />
                {seller.address}, {seller.city}, {seller.state} -{" "}
                {seller.pincode}
              </p>

              <h5>Country of Origin</h5>
              <p>India</p>

              <p className="product-code">
                <strong>Product Code:</strong> {productId}
              </p>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default SupplierInfoModal;

// import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";

// const SupplierInfoModal = ({ onClose, sellerId, productId }) => {
//   const [seller, setSeller] = useState(null);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     if (sellerId) fetchSeller();
//   }, [sellerId]);

//   const fetchSeller = async () => {
//     try {
//       const formData = new FormData();
//       formData.append("seller_id", sellerId);

//       const res = await fetch(
//         "https://cyberathon.com/streekatha/API/index.php/Master_controller/get_by_id_seller_registration",
//         {
//           method: "POST",
//           body: formData,
//         }
//       );

//       const result = await res.json();

//       if (result.status && result.data) {
//         setSeller(result.data);
//       }
//     } catch (err) {
//       console.error("Seller fetch error", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="supplier-modal-overlay">
//       <div className="supplier-modal-box">
//         <button className="close-btn" onClick={onClose}>×</button>

//         {loading && <p>Loading supplier info...</p>}

//         {!loading && seller && (
//           <>
//             <h4>More Information</h4>

//             <p><strong>Product Code:</strong> {productId}</p>

//             <h5>Manufacturer Details</h5>
//             <p>
//               <strong>Supplier Business Name:</strong> {seller.business_name}<br />
//               {seller.address}, {seller.city}, {seller.state} - {seller.pincode}
//             </p>

//             <h5>Country of Origin</h5>
//             <p>India</p>

//             {/* ✅ PAGE REDIRECT */}
//             <Link
//               to={`/contact-supplier/${productId}/${sellerId}`}
//               className="text-center d-block"
//             >
//               <button className="button3">
//                 Contact Supplier
//               </button>
//             </Link>
//           </>
//         )}
//       </div>
//     </div>
//   );
// };

// export default SupplierInfoModal;
